import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { Columns, Column } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const WrapperBox = styled(Box)`
  justify-content: center;
  position: relative;
`;

export const StyledTextPairing = styled(TextPairing)`
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 280px;
    }
  }
`;

export const DesktopContainer = styled(Box)`
  justify-content: center;
  position: relative;
`;

export const StyledColumns = styled(Columns)`
  z-index: 2;
  position: relative;
  @media screen and (min-width: 36rem) {
    max-width: 100%;
  }
  ${themeMediaQuery('below_sm')} {
    padding: 0;
    margin: auto;
  }
  ${themeMediaQuery('sm')} {
    max-width: 67.5rem;
  }
  ${themeMediaQuery('lg')} {
    max-width: 79.5rem;
  }
`;

export const StyledColumn = styled(Column)`
  ${themeMediaQuery('below_sm')} {
    padding: 0;
  }
  ${themeMediaQuery('sm')} {
    padding: 0 ${themeSpace(4)};
  }
  ${themeMediaQuery('md')} {
    padding: 0 ${themeSpace(6)};
  }
`;

export const StyledBox = styled(Box)`
  background: white;
  text-align: center;
  &:not(:first-child) {
    margin-top: ${themeSpace(10)};
  }
`;

export const AssetWrapper = styled(Box)`
  position: absolute;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  visibility: visible;
  &:not(:first-child) {
    visibility: hidden;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  border-radius: 4px;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;
